import React, { useState, useEffect, useRef  } from 'react';
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { RadioButton } from 'primereact/radiobutton';
import CityCombo from '../combos/CityCombo';
import ServiceCombo from '../combos/ServiceCombo';
import { InputTextarea } from 'primereact/inputtextarea';
import Table from 'react-bootstrap/Table';
import Laoding from '../shared/Laoding';

export default function BuyService(props) {
    const navigate = useNavigate();
    const [service, setService] = useState(null);
    const [taxPercent, setTaxPercent] = useState(0);
    const [tax, setTax] = useState(0);
    const [comment, setComment] = useState("");
    const [serviceNumber, setServiceNumber] = useState(1);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [checkDiscount, setCheckDiscount] = useState(false);
    const [discountMobile, setDiscountMobile] = useState("");
    const [discountToken, setDiscountToken] = useState("");
    const [discountValue, setDiscountValue] = useState(0);
    const [discountPercent, setDiscountPercent] = useState(0);
    const [loading, setLoading] = useState(true);
    const targetRef1 = useRef(null);

    useEffect(() => {
        
        var bs = util.getBuyService();
        if(bs != null){
            //setService({service:bs.service, taxPercent:bs.taxPercent});
            console.log("old service is>", bs.service)
            setService(bs.service);
            setServiceNumber(bs.serviceNumber);
            setComment(bs.comment);
        }
        setLoading(false);
    }, []);
    const onServiceComboLoaded = function(){
        util.scrollToElement(targetRef1, "start");
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "comment") setComment(val);
        else if(name === "serviceNumber"){
            if(val == '') val = '0';
            var sn = parseInt(val);
            if(sn <1) sn = 1;
            setServiceNumber(sn);
            if(service == null){
                setTax(0);
            }
            else{
                var tx = Math.floor((service.basePrice*taxPercent)/100);
                setTax(tx * sn);
            }
        }
    }
    const checkDataEntry = function(){
        if(service == null){
            setErrorMessage("نوع خدمت را انتخاب کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveBuyInLocal = ()=>{
        var modules = [];
        var buy = {
            productId:service.id,
            enName:service.enName,
            buyGoal:"buyService",
            productType:null,
            modules:modules,
            parameters :{
                number:serviceNumber,
                comment:comment,
            },
            price:(service.basePrice * serviceNumber - discountValue),
            tax:tax,
            discountToken:discountToken,
            discountMobile:discountMobile,

        };
        util.saveBuy(buy);
        var buyService = {
            service:service,
            serviceNumber:serviceNumber,
            comment:comment,
            taxPercent:taxPercent
        }
        util.saveBuyService(buyService);
    }
    const onContinueButtonClick = function(){
        if(!checkDataEntry()) return;
        setSaving(true);
        saveBuyInLocal();
        var b = util.isLogedInServer(setAsLoggedIn, setAsNotLoggedIn);
    }
    const setAsLoggedIn = function(){
        setSaving(false);
        console.log("is logged in");
        setRedirectUrl("/buy/product/summary")
    }
    const setAsNotLoggedIn = function(){
        setSaving(false);
        util.saveAfterLoginUrl("complete_buy_product");
        setRedirectUrl("/check-user-exist")
    }
    const checkDiscountToken = () =>{
        if(discountToken.length <12){
            setErorVisible(true);
            setErrorMessage("کد تخفیف باید حداقل 12 حرف یا رقم باشد");
            return;
        }
        // var check = util.IsMobileValid(discountMobile);
        // if(!check.valid){
        //     setErorVisible(true);
        //     setErrorMessage(check.msg);
        //     return;
        // }
        setCheckDiscount(true);
        var params = {login:{}, code:discountToken, mobile:discountMobile};
        var url = config.Server+`/payment/discount-token/check`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setDiscountPercent(response);
                var sn = serviceNumber;
                var cost = (service == null)? sn * service.basePrice: 0;
                var value = 0;
                value = Math.floor(((cost)*response)/100);
                setDiscountValue(value);
                setCheckDiscount(false);
                cost -= discountValue;
                if(cost < 0) cost = 0;
                var tx = Math.floor((cost*taxPercent)/100);
                setTax(tx);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setCheckDiscount(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setCheckDiscount(false);
        });
    }
    const onServiceSelected = function(val){
        console.log("service is>", val)
        var sn = serviceNumber;
        if(sn <= 0) sn = 1;
        setServiceNumber(sn);
        if(val == null){
            setTaxPercent(0);
            setService(null);
            setTax(0);        
        }
        else{
            if(val.service){
                setTaxPercent(val.taxPercent);
                setService(val.service);
                console.log("service base price is>", val.service.basePrice)
                var tx = Math.floor((((val.service.basePrice * sn)-discountValue)*val.taxPercent)/100);
                setTax(tx);
            }
            else{
                setTaxPercent(0);
                setService(null);
                setTax(0);        
            }
        }
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست خدمات..." />
                </Col>
            </Row>
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}} ref={targetRef1}>                
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>خرید خدمات</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <ServiceCombo onChange={(val)=>{onServiceSelected(val);}} onLoaded={()=>onServiceComboLoaded()} value={service} />                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <FloatLabel>
                                            <InputText value={serviceNumber} onChange={(e)=>{onInputChange(e, "serviceNumber")}} id="serviceNumber" onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                            <label htmlFor="serviceNumber">تعداد</label>
                                        </FloatLabel>
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <FloatLabel>
                                            <InputTextarea value={comment} onChange={(e)=>{onInputChange(e, "comment")}} id="comment" keyfilter="" maxLength={1000} className="p-inputtext-lg" style={{width:"100%", height:"120px", textAlign:"right", direction:"rtl"}} />
                                            <label htmlFor="comment">شرح</label>
                                        </FloatLabel>                                                    
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Table key={"discounttable"} style={{marginTop:"50px"}}>
                                            <tbody  key={"discounttablebody"}>
                                                <tr><td colSpan={2}>در صورتی که توکن تخفیف در اختیار دارید جهت بررسی و استفاده، مشخصات آنرا در کادر زیر وارد کنید</td></tr>
                                                <tr>
                                                    <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>کد تخفیف</td>
                                                    <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                        <InputText value={discountToken} onChange={(e) => {setDiscountToken(e.target.value); setDiscountValue(0);}} style={{width:"160px", textAlign:"center", direction:"ltr"}} maxLength={20} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مبلغ تخفیف</td>
                                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                        {util.SeperatePrice(discountValue) + " ("+discountPercent+"%)"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"center", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0"}} colSpan={2}>
                                                        <Button severity="Primary" loading={checkDiscount} onClick={()=>{checkDiscountToken()}} style={{borderRadius:"5px"}}>بررسی کد تخفیف</Button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{paddingTop:"30px"}}>
                                        <table style={{width:"100%"}}>
                                            <tbody>
                                                <tr>
                                                    <td style={{width:"50%", textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>قیمت پایه</td>
                                                    <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(((service == null)? 0 : service.basePrice))}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>جمع کل</td>
                                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(((service == null)? 0 : service.basePrice)*serviceNumber)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تخفیف</td>
                                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(discountValue) + " ("+discountPercent+"%)"}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مبلغ پس از تخفیف</td>
                                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice((((service == null)? 0 : service.basePrice)*serviceNumber)-discountValue)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>ارزش افزوده</td>
                                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(tax)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", padding:"10px", border:"1px dashed #b0b0b0", borderRight:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>مبلغ کل</td>
                                                    <td style={{textAlign:"right", padding:"10px", border:"1px dashed #b0b0b0", borderLeft:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>{util.SeperatePrice(((((service == null)? 0 : service.basePrice)*serviceNumber)-discountValue) + tax)}</td>
                                                </tr>
                                            </tbody>
                                        </table> 

                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button severity="success" onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;تائید و ادامه&nbsp;&nbsp;</Button>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}